import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RedirectComponent } from './redirect/redirect.component';
import { RegisterGuardService } from './shared/register-guard.service';
import { ConnectGuardService } from './shared/connect-guard.service';

const routes: Routes = [
  { path: "", component: RedirectComponent },
  { path: "auth", loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule) },
  { path: "connect", canActivate:[ConnectGuardService], loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)},
  { path: "register", canActivate:[RegisterGuardService], loadChildren: () => import('./register/register.module').then(m => m.RegisterModule)},
  { path: "reset-password", loadChildren: () => import('./reset-password/reset-password.module').then(m => m.ResetPasswordModule)},
  { path: "cockpit", loadChildren: () => import('./cockpit/cockpit.module').then(m => m.CockpitModule) },
  { path: "acceptInvite", loadChildren: () => import('./accept-invite/accept-invite.module').then(m => m.AcceptInviteModule) },
  { path: '**' , redirectTo: "/auth", pathMatch: 'full' }
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],//, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
